export const EVENT_FORMAT = {
  OFFLINE: 'offline',
  ONLINE: 'online',
};

export const DEFAULT_EVENT_FORMAT = EVENT_FORMAT.OFFLINE;

export const EVENT_FORMAT_OPTIONS = [
  { value: EVENT_FORMAT.OFFLINE, label: 'Offline' },
  { value: EVENT_FORMAT.ONLINE, label: 'Online' },
];

export const normalizeEventFormat = (value) => {
  const normalized = String(value ?? '')
    .trim()
    .toLowerCase();
  return normalized === EVENT_FORMAT.ONLINE ? EVENT_FORMAT.ONLINE : EVENT_FORMAT.OFFLINE;
};

export const isOnlineEventFormat = (value) => normalizeEventFormat(value) === EVENT_FORMAT.ONLINE;

export const resolveEventFormatFromApi = (event) =>
  normalizeEventFormat(event?.eventFormat ?? DEFAULT_EVENT_FORMAT);

export const resolveOnlineMeetingLinkFromApi = (event) =>
  String(event?.onlineMeetingLink ?? '').trim();
